import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { Subscription } from 'rxjs';
import { StorageService } from 'src/app/core/services/storage.service';
import { NgZone } from '@angular/core'
import { environment } from 'src/environments/environment';
import { getNetworkLogo } from 'src/app/core/utils/network-logo.util';
@Component({
  selector: 'app-ic-footer',
  templateUrl: './ic-footer.component.html',
  styleUrls: ['./ic-footer.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class IcFooterComponent implements OnInit {

  menuNames: any = [];
  userInfo: any = {};
  copyRightYear = new Date().getFullYear();
  userInfoSubscription: Subscription;
  openChat: boolean;
  loggedIn: boolean = false;
  settingsData: any = {};
  performer_details: any = {};
  settingsDataSubscription: Subscription;
  performerInfoSubscr: Subscription
  channelName: any;
  is_show_musicPlayer: boolean = false;
  mediaPlayerDataSubscription: Subscription;
  deviceData: Subscription;
  deviceType: any;
  org_info: any;
  org_id: any;
  assets_url = environment.assets_url;
  /** New-design footer (ENABLE_NEW_FOOTER, ic-footer-v2); the classic footer below is kept for false. */
  newFooter = (environment as any).enableNewFooter === true;
  constructor(public router: Router, private commanSubscribeService: CommanSubscribeService,
    private storageService: StorageService, public route: ActivatedRoute, private ngZone: NgZone,
    private commonSubscribeService: CommanSubscribeService,
  ) {

    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.settingsData = this.commanSubscribeService.icWebpageSettingsData;
      }
    });

  }


  ngOnInit() {
    document.body.classList.add("home");
    this.deviceType = this.commanSubscribeService.deviceType;
    this.deviceData = this.commanSubscribeService.getAppType().subscribe(response => {
      this.deviceType = response;
    })
    let perfomerInfoData = this.commanSubscribeService.perfomerInfoData;
    this.performer_details = perfomerInfoData.data && perfomerInfoData.data.Data && perfomerInfoData.data.Data[0] ? perfomerInfoData.data.Data[0].performer_details : '';
    this.channelName = perfomerInfoData.data && perfomerInfoData.data.Data && perfomerInfoData.data.Data[0] ? perfomerInfoData.data.Data[0].channel_name : '';
    this.performerInfoSubscr = this.commanSubscribeService.getPerfomerInfo().subscribe(response => {
      perfomerInfoData = response;
      this.performer_details = (perfomerInfoData&&perfomerInfoData.data&&perfomerInfoData.data.Data&&perfomerInfoData.data.Data[0])?
      perfomerInfoData.data.Data[0].performer_details:null;
      this.channelName = (perfomerInfoData&&perfomerInfoData.data&&perfomerInfoData.data.Data&&perfomerInfoData.data.Data[0])?
      perfomerInfoData.data.Data[0].channel_name:null;
    })

    this.settingsData = this.commanSubscribeService.icWebpageSettingsData;
    this.settingsDataSubscription = this.commanSubscribeService.getICWebpageThemeSettings().subscribe(response => {
      this.settingsData = response;
    });

    this.userInfo = this.commanSubscribeService.userInfo;
    this.userInfoSubscription = this.commanSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
    });
    let userInfo = this.storageService.getItem('user_Info');
    if (userInfo && userInfo.access_token && this.userInfo && this.userInfo.id) {
      this.loggedIn = true;
    } else {
      this.loggedIn = false;
    }
    // this.menuNames = ['home', 'creators', 'organizers', 'fans', 'browse'];
    this.menuNames = ['Home', 'Creators', 'Fans'];
    if (this.commanSubscribeService.mediaPlayerData.is_show_musicPlayer) {
      this.is_show_musicPlayer = true;
    } else {
      this.is_show_musicPlayer = false;
    }
    this.mediaPlayerDataSubscription = this.commanSubscribeService.getMediaPlayerData().subscribe(response => {
      if (response.key == "is_show_musicPlayer") {
        this.is_show_musicPlayer = response.value;
      }
    });


    this.commonSubscribeService.getPerfomerInfo().subscribe(
      (response) => {
        if(response&&response.data&&response.data.Data&&response.data.Data[0]){
          this.getOrgInfo(response.data.Data[0]['org_info'], response.data.Data[0]['organization_id']);
        }
      },
      (error) => {
        console.log(error);
      }
    )

  }

  get logoUrl(): string {
    return getNetworkLogo(this.commanSubscribeService.perfomerInfoData, this.settingsData);
  }

  getOrgInfo(data, id) {
    this.org_info = data;
    this.org_id = id;
  }

  goToRespectiveScreen(path) {
    if (!this.router.url.includes('/preview')) {
      if (path == 'home')
        this.router.navigateByUrl('');
      else if (path == 'contactus') {
        if (this.org_info) {
          this.router.navigate([this.commanSubscribeService.getChannelBasePath(this.channelName) + '/' + path], { state: { data: [this.org_info, this.org_id, this.channelName] } });
        }
      }
      else
        this.router.navigate([this.commanSubscribeService.getChannelBasePath(this.channelName) + '/' + path]);
      // sd
    }
  }

  redirectTo() {
    if (!this.router.url.includes('/preview')) {
      this.router.navigateByUrl('/');
    }
  }

  openKoopid() {
    this.openChat = !this.openChat;
  }

  ngOnDestroy() {
    if (this.userInfoSubscription)
      this.userInfoSubscription.unsubscribe();
    if (this.settingsDataSubscription)
      this.settingsDataSubscription.unsubscribe();
  }

}
